import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { customStyle } from '../../Components/Style';
import SummaryIcon from '../../Assets/Images/Employee/Summery';
import AttendanceByMemberIcon from '../../Assets/Images/Attendance/AttendanceByMember';
import AttendanceByHourIcon from '../../Assets/Images/Attendance/AttendancebyHour';
import AttendanceByMapIcon from '../../Assets/Images/Attendance/AttendanceByMap';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import '../../Assets/Css/Attendance.scss';
import AttendanceSummery from './AttendanceSummery';
import AttendanceDetails from './AttendanceDetails';
import AttendanceByMember from './AttendanceByMember';
import AttendanceByHour from './AttendanceByHour';
import AttendanceByLocation from './AttendanceByLocation';
import { Month, generateYearOptions, Department } from '../../Lib/utils';

const Employee = [
  { value: 'Employee1', label: 'Employee1' },
  { value: 'Employee2', label: 'Employee2' },
  { value: 'Employee3', label: 'Employee4' },
  { value: 'Employee4', label: 'Employee4' },
];

const Designation = [
  { value: 'all', label: 'all' },
  { value: 'director', label: 'director' },
  { value: 'team leader', label: 'team leader' },
  { value: 'designer', label: 'designer' },
  { value: 'developer', label: 'developer' },
  { value: 'hr', label: 'hr' },
];

const Late = [
  { value: 'all', label: 'all' },
  { value: 'yes', label: 'yes' },
  { value: 'no', label: 'no' },
];

function Attendance() {
  const [exportLoading, setExportrLoading] = useState(false);
  const [activeButton, setActiveButton] = useState('');

  console.log(activeButton, "<==aButton");

  const [selectFilters, setSelectedFilters] = useState({
    Employee: '',
    Department: '',
    Designation: '',
    Late: '',
    Month: '',
  });

  const navigate = useNavigate();
  const location = useLocation();
  const Year= generateYearOptions()

  useEffect(() => {
    if (location.pathname == '/attendance') {
      const path = location.pathname.slice(1);
      setActiveButton(path);
    } else if (location.pathname == '/attendance/member') {
      const path = location.pathname.slice(12);
      setActiveButton(path);
    } else if (location.pathname == '/attendance/byhour') {
      const path = location.pathname.slice(12);
      setActiveButton(path);
    }
  }, []);

  console.log(activeButton, 'btn');

  const handleClick = (buttonId, route) => {
    setActiveButton(buttonId);
    navigate(route);
  };

  return (
      <div className="task-viewEmployee-main">
        <div className="page-title">
          <h4>Attendance</h4>
        </div>

        <div className="row">
          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Employee}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Employee: data,
                  })
                }
                options={Employee}
                placeholder={'Employee'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Department}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Department: data,
                  })
                }
                options={Department}
                placeholder={'Department'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Designation}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Designation: data,
                  })
                }
                options={Designation}
                placeholder={'Designation'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Month}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Month: data,
                  })
                }
                options={Month}
                placeholder={'Month'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Year}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Year: data,
                  })
                }
                options={Year}
                placeholder={'Year'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="card-type">
              <Select
                value={selectFilters.Late}
                onChange={(data) =>
                  setSelectedFilters({
                    ...selectFilters,
                    Late: data,
                  })
                }
                options={Late}
                placeholder={'Late'}
                styles={customStyle}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#5757fe',
                    primary: '#5757fe',
                  },
                })}
              />
            </div>
          </div>

          <div className="col-lg-12 col-md-12  attandance-btn">
            <div>
              <button
                className="export-btn"
                id="exportBtn"
                // disabled={!checked || exportLoading}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/attendance/markattendance');
                }}
              >
                {/* {exportLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Export"
                        )} */}
                Mark Attendance
              </button>

              <button
                className="export-btn"
                id="exportBtn"
              // disabled={!checked || exportLoading}
              // onClick={(e) => {
              //     e.preventDefault();
              //     handleClick(totalSelectedIds, "export");
              // }}
              >
                {/* {exportLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        className="custom-spinner"
                                        role="status"
                                        aria-hidden="true"
                                    /> */}
                {/* ) : ( */}
                Import
                {/* )} */}
              </button>

              <button
                className="export-btn"
                id="exportBtn"
              // disabled={!checked || exportLoading}
              // onClick={(e) => {
              //     e.preventDefault();
              //     handleClick(totalSelectedIds, "export");
              // }}
              >
                {/* {exportLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        className="custom-spinner"
                                        role="status"
                                        aria-hidden="true"
                                    /> */}
                {/* ) : ( */}
                Export
                {/* )} */}
              </button>
            </div>

            <div className="navigation_btn">
              <button
                className={`btn1 ${activeButton === "attendance" ? "active" : ""}`}
                onClick={() => handleClick("attendance", "/attendance")}
              >
                <SummaryIcon color={activeButton === "attendance" ? "white" : "black"} bgColor={activeButton === "attendance" ? "black" : "white"} />
              </button>
              <button
                className={`btn1 ${activeButton === "member" ? "active" : ""}`}
                onClick={() => handleClick("member", "/attendance/member")}
              >
                <AttendanceByMemberIcon color={activeButton === "member" ? "white" : "black"} bgColor={activeButton === "member" ? "black" : "transparent"} />
              </button>
              <button
                className={`btn1 ${activeButton === "byhour" ? "active" : ""}`}
                onClick={() => handleClick("byhour", "/attendance/byhour")}
              >
                <AttendanceByHourIcon color={activeButton === "byhour" ? "white" : "black"} bgColor={activeButton === "byhour" ? "black" : "white"} />
              </button>
              <button
                className={`btn1 ${activeButton === "bylocation" ? "active" : ""}`}
                onClick={() => handleClick("bylocation", "/attendance/bylocation")}
              >
                <AttendanceByMapIcon color={activeButton === "bylocation" ? "white" : "black"} bgColor={activeButton === "bylocation" ? "black" : "transparent"} />
              </button>
            </div>

          </div>

          <div className=" col-lg-12 col-md-12">
            {location.pathname == '/attendance' && <AttendanceSummery />}
            {location.pathname == '/attendance/member' && <AttendanceByMember />}
            {location.pathname == '/attendance/details' && <AttendanceDetails />}
            {location.pathname == '/attendance/byhour' && <AttendanceByHour />}
            {location.pathname == '/attendance/bylocation' && <AttendanceByLocation />}
          </div>
        </div>
      </div>
  );
}

export default Attendance;
